import { render, staticRenderFns } from "./EmdWaitingMobileView.vue?vue&type=template&id=070813da&scoped=true&"
import script from "./EmdWaitingMobileView.vue?vue&type=script&lang=js&"
export * from "./EmdWaitingMobileView.vue?vue&type=script&lang=js&"
import style0 from "./EmdWaitingMobileView.vue?vue&type=style&index=0&id=070813da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070813da",
  null
  
)

export default component.exports